import { DateUtils } from "@yupma/ui-kit";

export class AuthTokenMeta {
    authToken: string;
    authTokenCreationTimeStamp: number;

    constructor(authToken: string) {
        this.authToken = authToken;
        this.authTokenCreationTimeStamp = DateUtils.getCurrentTimeStamp();
    }

    static fromJSON(authTokenObject: any): AuthTokenMeta {
        const authTokenMeta = new AuthTokenMeta('')
        if (authTokenObject) {
            authTokenMeta.authToken = authTokenObject.authToken ? authTokenObject.authToken : '';
            authTokenMeta.authTokenCreationTimeStamp = authTokenObject.authTokenCreationTimeStamp ? authTokenObject.authTokenCretaionTimeStamp : DateUtils.getCurrentTimeStamp();
        }
        return authTokenMeta
    }
}